import React, { Component } from 'react';

import { Label, Headline, Disclaimer, Button } from '../../theme';
import { Stove } from '../../svg';
import { isMobile } from '../../util';


class StoveSolution extends Component {
  render() {
    return (
      <div id="PlitaSol" className="container__fluid page__solution">

        <div className="start bike">
          <Stove.Bike isMobile={isMobile} />
        </div>


        <div className="w__flex w__flex-column Justify-center Justify-start__mobile">
          <Label
            marginLeft={isMobile ? false : '20vw'}
            background="#840050"
          >
            solutia tatalui
          </Label>
          {
            isMobile
              ? <Headline small >
                <p style={{ color: '#d33c64' }}>BLOCARE DISPLAY? OPRIRE</p>
                <p style={{ color: '#d33c64' }}>AUTOMATA? CUMPARA O PLITA</p>
                <p style={{ color: '#d33c64' }}>ELECTRICA INCORPORABILA,</p>
                <p style={{ color: '#d33c64' }}>MODEL NOU, SI UITA DE</p>
                <p style={{ color: '#d33c64', position: 'relative' }}>
                  ACCIDENTE SI CONSUM
                </p>
                <p style={{ color: '#d33c64' }}>INUTIL DE ENERGIE!</p>
              </Headline>
              : <Headline padding="20vw" small alignLeft >
                <p style={{ color: '#d33c64' }}>CUMPARA UN MODEL NOU DE PLITA</p>
                <p style={{ color: '#d33c64' }}>ELECTRICA INCORPORABILA, CU BLOCARE</p>
                <p style={{ color: '#d33c64' }}>DISPLAY SI OPRIRE AUTOMATA SI UITA</p>
                <p style={{ color: '#d33c64' }}>DE GRIJA PORNIRII ACCIDENTALE</p>
                <p style={{ color: '#d33c64', position: 'relative' }}>
                  A ARZATOARELOR SI A CONSUMULUI
                  <span className="end todler">
                    <Stove.Todler />
                  </span>
                </p>
                <p style={{ color: '#d33c64' }}>INUTIL DE ENERGIE!</p>
              </Headline>
          }

          <div className="w__flex Align-right w__flex-column__mobile Align-left__mobile">
            <Disclaimer
              style={{
                paddingLeft: isMobile ? '0' : '20vw'
              }}
            >
              <span>
                Comparativ cu cele din clasa A, <strong>plitele electrice
                <br className="mobile__hidden" />
                  &nbsp;din clasa A+ consuma cu 13% mai putina energie electrica.</strong>

              </span>
            </Disclaimer>
            <span>
              <Button to="https://www.arctic.ro/produse-incorporabile/plite.html" arctic>
                <span className="mobile__hidden">Vezi</span>  produsele arctic
              </Button>
              {
                isMobile && (
                  <Button enel >
                    <span className="mobile__hidden">Vezi</span>  oferta enel
                </Button>
                )
              }
            </span>
          </div>
        </div>
        {
          !isMobile && (
            <Button enel >
              <span className="mobile__hidden">Vezi</span>  oferta enel
            </Button>
          )
        }
      </div>
    );
  }
}

export default StoveSolution;


// WEBPACK FOOTER //
// ./src/components/pages/Plita/StoveSolution.jsx